export default function pluralCheck(number, singular, plural) {
    if (number === 1) return singular;
        
    return plural;
}